import { PrefectureCode } from "enums/prefecture";
import { CategoryModel } from "models";
import React from "react";
import CorpListSideMenuTreeNode from "./CorpListSideMenuTreeNode";

type PROPS = {
  /** カテゴリの全情報 */
  categoryList: CategoryModel[];
  /** 選択中の大カテゴリ */
  largeCategoryID?: string;
  /** 選択中の中カテゴリ */
  mediumCategoryID?: string;
  /** 中カテゴリの変更ハンドラ */
  onChangeMediumCategoryID: (id?: string) => void;

  /** 選択中の都道府県ID */
  prefectureCode?: string;
  /** 都道府県IDの変更ハンドラ */
  onChangePrefectureCode: (code?: PrefectureCode) => void;
};

const CorpListSideMenu: React.FC<PROPS> = (props) => {
  const selectedID = props.mediumCategoryID;

  const [largeCategoryName, setLargeCategoryName] = React.useState("");
  const [items, setItems] = React.useState<CategoryModel[] | null>(null);
  const [prefectureCode, setPrefectureCode] = React.useState("");

  React.useEffect(() => {
    const id = props.largeCategoryID;
    const largeCategory = props.categoryList.find((v) => v.id === id);
    console.log(largeCategory);
    if (largeCategory) {
      setLargeCategoryName(largeCategory.name);
      setItems(largeCategory.list);
    } else {
      setLargeCategoryName("すべて");
      setItems(null);
    }
  }, [props.categoryList, props.largeCategoryID]);

  React.useEffect(() => {
    setPrefectureCode(props.prefectureCode ?? "");
  }, [props.prefectureCode]);

  return (
    <div className="w-80 bg-slate-200 border-r">
      <div className="p-4 font-bold">{largeCategoryName}</div>
      {items && (
        <div className="flex flex-col gap-4 my-4 ml-8">
          <label className="cursor-pointer">
            <input
              type="radio"
              name="sub-category"
              value={selectedID}
              checked={selectedID === undefined}
              onChange={() => props.onChangeMediumCategoryID()}
            />
            <span className="ml-2">すべて</span>
          </label>
          {items.map((item, index) => (
            <label className="cursor-pointer" key={index}>
              <input
                type="radio"
                name="sub-category"
                value={selectedID}
                checked={selectedID === item.id}
                onChange={() => props.onChangeMediumCategoryID(item.id)}
              />
              <span className="ml-2">{item.name}</span>
            </label>
          ))}
        </div>
      )}

      <div className="my-16 mx-4 flex flex-col gap-4">
        <label className="cursor-pointer">
          <input
            type="radio"
            name="prefectureCode"
            checked={prefectureCode === ""}
            onChange={() => {
              props.onChangePrefectureCode();
            }}
          />
          <span className="ml-2">全国から探す</span>
        </label>
        <CorpListSideMenuTreeNode
          label="北海道・東北"
          prefectures={[
            PrefectureCode._01_HOKKAIDO,
            PrefectureCode._02_AOMORI,
            PrefectureCode._03_IWATE,
            PrefectureCode._04_MIYAGI,
            PrefectureCode._05_AKITA,
            PrefectureCode._06_YAMAGATA,
            PrefectureCode._07_FUKUSHIMA,
          ]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
        <CorpListSideMenuTreeNode
          label="関東"
          prefectures={[
            PrefectureCode._08_GUNMA,
            PrefectureCode._09_TOCHIGI,
            PrefectureCode._10_IBARAKI,
            PrefectureCode._11_SAITAMA,
            PrefectureCode._12_CHIBA,
            PrefectureCode._13_TOKYO,
            PrefectureCode._14_KANAGAWA,
          ]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
        <CorpListSideMenuTreeNode
          label="東海"
          prefectures={[PrefectureCode._23_AICHI, PrefectureCode._21_GIFU, PrefectureCode._24_MIE, PrefectureCode._22_SHIZUOKA]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
        <CorpListSideMenuTreeNode
          label="北陸・甲信越"
          prefectures={[
            PrefectureCode._19_YAMANASHI,
            PrefectureCode._20_NAGANO,
            PrefectureCode._15_NIGATA,
            PrefectureCode._16_TOYAMA,
            PrefectureCode._17_ISHIKAWA,
            PrefectureCode._18_FUKUI,
          ]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
        <CorpListSideMenuTreeNode
          label="近畿"
          prefectures={[
            PrefectureCode._25_SHIGA,
            PrefectureCode._26_KYOTO,
            PrefectureCode._27_OSAKA,
            PrefectureCode._28_HYOGO,
            PrefectureCode._29_NARA,
            PrefectureCode._30_WAKAYAMA,
          ]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
        <CorpListSideMenuTreeNode
          label="中国・四国"
          prefectures={[
            PrefectureCode._31_TOTTORI,
            PrefectureCode._32_SHIMANE,
            PrefectureCode._33_OKAYAMA,
            PrefectureCode._34_HIROSHIMA,
            PrefectureCode._35_YAMAGUCHI,
            PrefectureCode._37_KAGAWA,
            PrefectureCode._38_EHIME,
            PrefectureCode._36_TOKUSHIMA,
            PrefectureCode._39_KOCHI,
          ]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
        <CorpListSideMenuTreeNode
          label="九州・沖縄"
          prefectures={[
            PrefectureCode._40_FUKUOKA,
            PrefectureCode._41_SAGA,
            PrefectureCode._42_NAGASAKI,
            PrefectureCode._43_KUMAMOTO,
            PrefectureCode._44_OITA,
            PrefectureCode._45_MIYAZAKI,
            PrefectureCode._46_KAGOSHIMA,
            PrefectureCode._47_OKINAWA,
          ]}
          selectedPrefectureCode={prefectureCode}
          onChangePrefectureCode={props.onChangePrefectureCode}
        />
      </div>
    </div>
  );
};

export default CorpListSideMenu;
